// Based on IIFE pattern. See https://en.wikipedia.org/wiki/Immediately_invoked_function_expression
export const run = <T>(fn: () => T): T => fn()

export const tryCatch = <T>(
  fn: () => T
): T extends Promise<any>
  ? Promise<
      | { success: true; result: Awaited<T>; error: null }
      | { success: false; result: null; error: Error }
    >
  :
      | { success: true; result: T; error: null }
      | { success: false; result: null; error: Error } => {
  try {
    const result = fn()
    if (result instanceof Promise) {
      return result
        .then((value) => ({ success: true, result: value, error: null }))
        .catch((error) => ({
          success: false,
          result: null,
          error: error as Error,
        })) as any
    }
    return { success: true, result, error: null } as any
  } catch (error) {
    return { success: false, result: null, error: error as Error } as any
  }
}
